import { useState, useRef, useEffect } from 'react';
import { Box, Hidden, Tab, Tabs } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ProgramTabContent from '@/components/04_templates/ProgramsPage/ProgramTabContent';
import EventsTabContent from '@/components/04_templates/ProgramsPage/EventsTabContent';
import StayInTouch from '@/components/04_templates/ProgramsPage/StayInTouch';

const useStyles = makeStyles((theme) => ({
  tabs: {
    borderRight: '2px solid #3C8047',
    paddingBottom: '50px',
    minWidth: '250px',
    maxHeight: 'fit-content',
    position: 'sticky',
    top: '50px',
  },
  tab: {
    fontFamily: 'Lato',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '27px',
    textAlign: 'left',
    paddingLeft: '20px',
    textTransform: 'none',
    alignItems: 'flex-start'
  },

  tabPanel: {
    paddingLeft: '32px',
    [theme.breakpoints.down('lg')]: {
      paddingLeft: '0px',
    },
  },
}));

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabs({ node }) {
  const classes = useStyles();
  const itemRef = useRef(null);
  const [value, setValue] = useState(0);
  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (itemRef && itemRef.current) {
      window.scrollTo({
        top: itemRef.current.offsetTop - 50,
        behavior: 'smooth',
      });
    }
  });

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: 'background.paper',
        display: 'flex',
        paddingBottom: '100px',
      }}
    >
      <Hidden lgDown>
        <Tabs
          orientation="vertical"
          value={value}
          onChange={handleChange}
          className={classes.tabs}
        >
          <Tab
            disableRipple
            label="Programs"
            {...a11yProps(0)}
            className={classes.tab}
            style={{
              borderLeft: value === 0 ? '5px solid #3C8047' : '',
            }}
          />
          <Tab
            disableRipple
            label="Events"
            {...a11yProps(1)}
            className={classes.tab}
            style={{
              borderLeft: value === 1 ? '5px solid #3C8047' : '',
            }}
          />
          <Tab
            disableRipple
            label="Meet the Team"
            {...a11yProps(2)}
            className={classes.tab}
            style={{
              borderLeft: value === 2 ? '5px solid #3C8047' : '',
            }}
          />
        </Tabs>
      </Hidden>
      <Box className={classes.tabPanel}>
        <Box ref={value === 0 ? itemRef : null}>
          <ProgramTabContent node={node} />
        </Box>
        <Box ref={value === 1 ? itemRef : null}>
          <EventsTabContent />
        </Box>
        <Box ref={value === 2 ? itemRef : null}>
          <StayInTouch />
        </Box>
      </Box>
    </Box>
  );
}
